import ReportTypes from '@/models/ReportTypes';

export default class ReportTypesRepository {
    public static getAll() {
        return ReportTypes.all();
    }
}
